<template>
  <div class="container vip_benefit">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>权益详细</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="vip_benefit_title">
      <div class="vip_benefit_title_title">{{type_name}}会员</div>
      <div class="vip_benefit_title_stitle">{{type_num}}项会员权益</div>
      <div class="clearboth"></div>
    </div>
    <div class="vip_benefit_cont">
      <van-tabs v-model="activeMMM" swipeable :ellipsis="false" :animated="true" class="vipBenefit_tablist">
        <van-tab v-for="(item,index) in tabs" :title="item.title" :name="index" :key="index">
          <div class="vip_benefit_tab">
            <div class="vip_benefit_tab_item">
              <div class="vip_benefit_tab_title">特权内容</div>
              <div class="vip_benefit_tab_cont" v-html="item.tx"></div>
              <!-- <div class="vip_benefit_tab_title">使用指南</div>
              <div class="vip_benefit_tab_cont" v-html="item.zn"></div> -->
            </div>
            <div class="vip_benefit_tab_item">
              <!-- <div class="vip_benefit_tab_title">特权内容</div>
              <div class="vip_benefit_tab_cont" v-html="item.tx"></div> -->
              <div class="vip_benefit_tab_title">使用指南</div>
              <div class="vip_benefit_tab_cont" v-html="item.zn"></div>
            </div>
            <div class="vip_benefit_tab_cont_viphotal" v-show="item.title=='精选星级酒店'" @click="showallstadium()">查看酒店名单 &gt;</div>
            <!---->
          </div>

        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  import {getWeek} from '../../lib/utils.js'
  export default {
    data() {
      return {
        type:'',
        type_name:'',//类型名称
        type_num:0,//类型权益数量
        activeName:0,
        tabs:[
          // {'title':'88超低价预约',tx:'超低价预约高端酒店泳健、瑜伽服务，88元/次，全年无限次；',zn:'本人预约88元/次，携亲友同行，亲友188元次'},
          // {'title':'安心退订保障',tx:'更加方便快捷的会员预约退订服务。轻松享受会员体验；',zn:'预约说明：最早可提前一天预约心仪酒店，方便快捷；<br />免费退订：在距离使用日期24小时前可享受免费退订，安心有保障'},
          {'title':'专项服务免费',tx:'一对一管家服务，为会员提供更多便捷的优质服务。',zn:'会员专线：400-630-5888 服务时间：9:00-18:00'},

        ],
        // tabsm:[],
        first_benefit_fit_time:'',
        activeMMM:0
      }
    },
    created() {

      // // // // console.log(this.activeMMM)
      // // // // console.log(this.$route.params.card_no)
      this.getBenefitTime()
    },
    watch: { },
    mounted() { },
    methods: {
      showallstadium(){
        this.$router.push({
          name:'allstadium',
          params:{
            type:'1'
          }
        })
      },
      getBenefitTime(){
        var $this = this;
        if(this.$route.params.card_no=='no'){
          this.getCardType($this.$route.params.type)
          return
        }
        this.getCardType($this.$route.params.type)
      },
      getCardType(type){
        //
        // {'title':'安心退订保障',tx:'更加方便快捷的会员预约退订服务。轻松享受会员体验；',zn:'预约说明：最早可提前一天预约心仪酒店，方便快捷；<br />免费退订：在距离使用日期24小时前可享受免费退订，安心有保障'},
        var sportype1={
          'title':'安心退订保障',
          tx:'1. 方便快捷的会员线上退订服务，符合线上免费退订规则即可享受免费退订服务；<br />2. 操作方式：在“我的” -> “我的预约” -> “订单详情” 中点击“申请退订”即可。',
          zn:"<div style='font-weight: bold;'>退订规则</div><br />"+
            '1. 付费退订：<br />'+
            ' 　　游泳健身服务：在距离到店时间24小时前可在线上免费申请退订（如，用户预约2月11日 19:00到店使用，则在2月10日18:59分前可进行免费退订），退订成功后会原路返还所付金额，不符合退订规则的均视为服务已使用，单次付费金额不予退还；<br />'+
            '　　瑜伽课程服务：在距离开课时间3小时前可在线上免费申请退订（如，用户预约2月11日13:00-14:00的瑜伽课程，则在2月11日09:59分前可进行免费退订），退订成功后会原路返还所付金额，不符合预约取消规则的均视为服务已使用，单次付费金额不予退还。<br />'+
            '<br />'+
            '2. 权益退订：所有免费权益只在使用周期内有效。会员使用免费权益预约权益周期外的游泳健身或瑜伽服务时，若退订时间超过本次免费权益可使用周期，即使满足到店使用时间24小时前申请退订，此次免费权益也视为已使用，不予退还。（如钻石会员于本周三预约了下周三使用，又于下周一申请退订，则本周的免费权益已过期，视作已使用）。'
        }
        var sportype2={
                  'title':'安心退订保障',
                  tx:'1. 方便快捷的会员线上退订服务，符合线上免费退订规则即可享受免费退订服务；<br />2. 操作方式：在“我的” -> “我的预约” -> “订单详情” 中点击“申请退订”即可。',
                  zn:"<div style='font-weight: bold;'>退订规则</div><br />"+
                      '1. 付费退订：<br />'+
                      '　　游泳健身服务：在距离到店时间24小时前可在线上免费申请退订（如，用户预约2月11日 19:00到店使用，则在2月10日18:59分前可进行免费退订），退订成功后会原路返还所付金额，不符合退订规则的均视为服务已使用，单次付费金额不予退还；<br />'+
                      '　　瑜伽课程服务：在距离开课时间3小时前可在线上免费申请退订（如，用户预约2月11日13:00-14:00的瑜伽课程，则在2月11日09:59分前可进行免费退订），退订成功后会原路返还所付金额，不符合预约取消规则的均视为服务已使用，单次付费金额不予退还。<br />'+
                      '<br />'+
                      '2. 权益退订：所有免费权益只在使用周期内有效。会员使用免费权益预约权益周期外的游泳健身或瑜伽服务时，若退订时间超过本次免费权益可使用周期，即使满足到店使用时间24小时前申请退订，此次免费权益也视为已使用，不予退还。（如钻石会员于本周三预约了下周三使用，又于下周一申请退订，则本周的免费权益已过期，视作已使用）。'
                }
        // var sportype2={'title':'安心退订保障',tx:'更加方便快捷的会员预约退订服务。轻松享受会员体验；',zn:'预约说明：最早可提前3小时预约心仪酒店，方便快捷；<br />免费退订：在距离使用日期3小时前可享受免费退订，安心有保障'}
        if(this.$route.params.stype=='fit'){
          this.tabs.unshift(sportype1)
        }else{
          this.tabs.unshift(sportype2)
        }
        //
        // // // console.log(this.$route.params.disc)
        var dis1={
          'title':'88超低价预约',
          tx:'1. 斐燃会员预约高端酒店游泳健身、瑜伽服务，可享受88元/次的超低价格，携亲友同行，亲友也可享受188元/次，全年不限次；<br />2. 方便快捷的会员线上预约服务，最多可预约7天以内的日期；<br />3. 操作方式：关注“斐燃生活”公众号进行预约即可。（注：只接受线上预约，如未通过线上成功预约直接去酒店健身中心的会员，酒店概不接待）',
          zn:"<div style='font-weight: bold;'>预约规则</div><br />"+
              '1. 游泳健身服务：需至少提前一天在线上进行预约；<br />'+
              '2. 瑜伽课程服务：需至少提前3小时在线上进行预约，瑜伽为课程制，需要达到2人或2人以上方可成团，如会员预约了某酒店某节课程，但在距离开课时间3小时前仍未凑满2人，则成团失败，客服会主动联系会员将订单取消或者修改预约时间，取消后会原路返还所付的权益或金额。<br />'+
              '<br />'+
              "<div style='font-weight: bold;'>注意事项</div><br />"+
              '1. 服务内容说明：游泳健身视作一项服务内容，瑜伽视作另一项服务内容。同一次预约中，游泳健身和瑜伽不可同时使用。若只预约了其中一项服务，且未经允许擅自使用了另一项服务内容，则需扣除三次免费权益，如剩余会员权益不足三次，则会员必须按酒店规定，补缴酒店健身中心单次门市价（如预约瑜伽课程的会员只可使用健身中心的更衣室和沐浴设施，若使用酒店的健身设施、泳池、桑拿等，会员本人需扣除权益或另行支付）。若会员不及时补缴费用，一切会员权益都将被冻结，且“合伽体育”可拒绝为该会员办理任何形式的退会退费；<br />'+
              '2. 实名注册：由于酒店必须进行实名登记入场，会员在注册购买会员时必须以本人真实姓名进行注册。如因会员未按照规定实名登记而无法入场造成的经济损失，该次权益或所付金额不做退还，且“合伽体育”不承担责任并不予任何赔偿（注：实名指身份证上的全名，不能是姓氏或英文名。外籍人员可填写英文名。）；<br />'+
              '3. 禁止事项：会员不得利用“合伽体育”提供的场地私自教授课程或进行相关活动、会员不得违反酒店健身和游泳场所的使用规定。若因会员不遵守酒店规则或违反相关规定，导致酒店拒绝为其服务或者酒店将该会员加入黑名单，“合伽体育”不承担任何责任；<br />'+
              '4. 未成年人预订：16岁以下青少年和儿童必须由家长陪同才可使用，建议家长和儿童同时开通会员（家长是否需要另外购票，具体以各酒店规则为主）；<br />'+
              '5. 老年人预约：根据酒店健身中心规定，为安全起见，游泳和健身中心不接待年龄在70岁以上（包括70岁）的用户，瑜伽中心不接待65岁以上（包括65岁）的用户；<br />'+
              '6. 酒店数量：由于季节变化或酒店健身中心经营原因，酒店健身中心数量随时会有调整；<br />'+
              '7. 预约限流：酒店游泳健身是限流服务，每家酒店每日库存数量有限，部分热门酒店会存在“预约已满”情况。如遇约满，会员可改约其他日期或改约其他酒店；<br />'+
              '8. 防疫事项：疫情期间请配合酒店的入场要求，测量体温、出示健康码；<br />'+
              '9. 到店使用规则：由于所有五星级酒店健身中心需出示本人身份证后方可入场，会员在使用时需向酒店健身中心工作人员提供有效身份证件（如线上与亲友一同预约，入场时亲友也需出示本人身份证件），并且出示预约成功短信，核销验证通过后即可使用；<br />'+
              '注：由于酒店健身中心预约数量实时更新，因此也不排除具体预订时库存更改的情况，请以最终预订提醒及客服告知为准。<br />'+
              '<br />'+
              '注：所有注意事项只限目前所知情形，服务商有权变更相关信息。<br />'+
              '如有任何与服务预约相关的事宜，可致客服热线400-630-5888咨询。<br />',
        }
        var dis2={
          'title':'五折超低价预约',
          tx:'1. 斐燃会员预约高端酒店游泳健身、瑜伽服务，可享受门市价五折/次的超低价格，携亲友同行，亲友也可享受门市价五折/次，全年不限次；<br />2. 方便快捷的会员线上预约服务，最多可预约7天以内的日期；<br />3. 操作方式：关注“斐燃生活”公众号进行预约即可。（注：只接受线上预约，如未通过线上成功预约直接去酒店健身中心的会员，酒店概不接待）<br />',
          zn:"<div style='font-weight: bold;'>预约规则</div><br />"+
              '1. 游泳健身服务：需至少提前一天在线上进行预约；<br />'+
              '2. 瑜伽课程服务：需至少提前3小时在线上进行预约，瑜伽为课程制，需要达到2人或2人以上方可成团，如会员预约了某酒店某节课程，但在距离开课时间3小时前仍未凑满2人，则成团失败，客服会主动联系会员将订单取消或者修改预约时间，取消后会原路返还所付的权益或金额。<br />'+
              '<br />'+
              "<div style='font-weight: bold;'>注意事项</div><br />"+
              '1. 服务内容说明：游泳健身视作一项服务内容，瑜伽视作另一项服务内容。同一次预约中，游泳健身和瑜伽不可同时使用。若只预约了其中一项服务，且未经允许擅自使用了另一项服务内容，则需扣除三次免费权益，如剩余会员权益不足三次，则会员必须按酒店规定，补缴酒店健身中心单次门市价（如预约瑜伽课程的会员只可使用健身中心的更衣室和沐浴设施，若使用酒店的健身设施、泳池、桑拿等，会员本人需扣除权益或另行支付）。若会员不及时补缴费用，一切会员权益都将被冻结，且“合伽体育”可拒绝为该会员办理任何形式的退会退费；<br />'+
              '2. 实名注册：由于酒店必须进行实名登记入场，会员在注册购买会员时必须以本人真实姓名进行注册。如因会员未按照规定实名登记而无法入场造成的经济损失，该次权益或所付金额不做退还，且“合伽体育”不承担责任并不予任何赔偿（注：实名指身份证上的全名，不能是姓氏或英文名。外籍人员可填写英文名。）；<br />'+
              '3. 禁止事项：会员不得利用“合伽体育”提供的场地私自教授课程或进行相关活动、会员不得违反酒店健身和游泳场所的使用规定。若因会员不遵守酒店规则或违反相关规定，导致酒店拒绝为其服务或者酒店将该会员加入黑名单，“合伽体育”不承担任何责任；<br />'+
              '4. 未成年人预订：16岁以下青少年和儿童必须由家长陪同才可使用，建议家长和儿童同时开通会员（家长是否需要另外购票，具体以各酒店规则为主）；<br />'+
              '5. 老年人预约：根据酒店健身中心规定，为安全起见，游泳和健身中心不接待年龄在70岁以上（包括70岁）的用户，瑜伽中心不接待65岁以上（包括65岁）的用户；<br />'+
              '6. 酒店数量：由于季节变化或酒店健身中心经营原因，酒店健身中心数量随时会有调整；<br />'+
              '7. 预约限流：酒店游泳健身是限流服务，每家酒店每日库存数量有限，部分热门酒店会存在“预约已满”情况。如遇约满，会员可改约其他日期或改约其他酒店；<br />'+
              '8. 防疫事项：疫情期间请配合酒店的入场要求，测量体温、出示健康码；<br />'+
              '9. 到店使用规则：由于所有五星级酒店健身中心需出示本人身份证后方可入场，会员在使用时需向酒店健身中心工作人员提供有效身份证件（如线上与亲友一同预约，入场时亲友也需出示本人身份证件），并且出示预约成功短信，核销验证通过后即可使用。<br />'+
              '注：由于酒店健身中心预约数量实时更新，因此也不排除具体预订时库存更改的情况，请以最终预订提醒及客服告知为准。<br />'+
              '<br />'+
              '注：所有注意事项只限目前所知情形，服务商有权变更相关信息。<br />'+
              '如有任何与服务预约相关的事宜，可致客服热线400-630-5888咨询。<br />',
        }
        // {'title':'88超低价预约',tx:'超低价预约高端酒店泳健、瑜伽服务，88元/次，全年无限次；',zn:'本人预约88元/次，携亲友同行，亲友188元次'},

        if(this.$route.params.disc=='a1'){
          this.tabs.unshift(dis1)
        }else{
          this.tabs.unshift(dis2)
        }

        var params_zn1=''
        var params_zn2=''
        this.activeMMM=2
        if(this.first_benefit_fit_time==''){
          params_zn1= '1. 斐燃会员的免费权益以下单时间为权益的使用时间。例如：会员用户第一周和第二周各有一次权益，该会员在第一周的周日使用免费权益下单，预约了第二周的周三到酒店运动的订单，那么在第二周时依旧可以使用一次权益下单；'+
                      '<br />2. 该免费权益可用于预约游泳健身服务、瑜伽服务；'+
                      '<br />3. 如需查看免费权益使用明细，请在“斐燃会员”->“权益使用明细”下查看。'
          params_zn2= '1. 斐燃会员的免费权益以下单时间为权益的使用时间。例如：会员用户当年度2月份和3月份各有一次权益，该会员在2月28日进行了权益下单，预约了3月2日到酒店运动的订单，那么在3月份时依旧可以使用一次权益下单；'+
                      '<br />2. 该免费权益可用于预约游泳健身服务、瑜伽服务；'+
                      '<br />3. 如需查看免费权益使用明细，请在“斐燃会员”->“权益使用明细”下查看。'
        }else{

          // // // console.log(this.first_benefit_fit_time)
          // // // console.log((this.first_benefit_fit_time).substring(0,4))
          // // // console.log((this.first_benefit_fit_time).substring(5,7))
          // // // console.log((this.first_benefit_fit_time).substring(8,10))
          var timstmp=(this.first_benefit_fit_time).substring(0,4)+'/'+(this.first_benefit_fit_time).substring(5,7)+'/'+(this.first_benefit_fit_time).substring(8,10)
          // // // console.log(timstmp)
          // // // console.log(getWeek(timstmp))

          params_zn1= '1. 尊敬的会员，免费权益的扣除以自然周进行计算，您本张会员卡首次免费权益的最晚使用截止时间为'+this.first_benefit_fit_time+'（'+getWeek(timstmp)+'），请尽快使用，免费权益每周可使用一次，如当周未使用，权益过期后作废不累积；'+
                      '<br />2. 斐燃会员的免费权益以下单时间为权益的使用时间。例如：会员用户第一周和第二周各有一次权益，该会员在第一周的周日使用免费权益下单，预约了第二周的周三到酒店运动的订单，那么在第二周时依旧可以使用一次权益下单；'+
                      '<br />3. 该免费权益可用于预约游泳健身服务、瑜伽服务；'+
                      '<br />4. 如需查看免费权益使用明细，请在“斐燃会员”->“权益使用明细”下查看。'

          params_zn2= '1. 尊敬的会员，免费权益的扣除以自然月进行计算，您本张会员卡首次免费权益的最晚使用截止时间为'+this.first_benefit_fit_time+'（'+getWeek(timstmp)+'），请尽快使用，免费权益每月可使用一次，如当月未使用，权益过期后作废不累积；'+
                      '<br />2. 斐燃会员的免费权益以下单时间为权益的使用时间。例如：会员用户当年度2月份和3月份各有一次权益，该会员在2月28日进行了权益下单，预约了3月2日到酒店运动的订单，那么在3月份时依旧可以使用一次权益下单；'+
                      '<br />3. 该免费权益可用于预约游泳健身服务、瑜伽服务；'+
                      '<br />4. 如需查看免费权益使用明细，请在“斐燃会员”->“权益使用明细”下查看。'
        }

        var params_tx1='1. 斐燃 | 钻石会员一年共52次免费权益，1周使用1次，仅限当周使用，权益扣除按自然周计算，权益过期作废不累积。'
        var params_tx2='1. 斐燃 | 铂金会员一年共12次免费权益，1个月使用1次，仅限当月使用，权益扣除按自然月计算，权益过期作废不累积。'
        var params1={'title':'52次免费权益',tx:params_tx1,zn:params_zn1}
        var params2={'title':'12次免费权益',tx:params_tx2,zn:params_zn2}
        // tabs
        if(type==2){
          this.tabs.unshift(params2)
        }else if(type==3){
          this.tabs.unshift(params1)
        }



        this.type=type
        var tabj={'title':'会员生日福利',tx:'1.	黄金会员生日当天收到一张价值88元的“生日券”，用于抵扣高端酒店游泳健身或瑜伽服务的预订费用（有效期14天）；<br>2.	生日祝福短信。',zn:
                 "<div><div style='font-weight: bold;'>黄金会员生日权益</div>"+
                  "<br />1.	黄金会员生日当天收到一张价值88元的“生日券”，用于抵扣高端酒店游泳健身或瑜伽服务的预订费用（有效期14天）；"+
                  "<br />2.	该“生日券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
                  "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一份生日券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
                  "<br />4.	该“生日券”只可自用不得转赠，过期作废。</div>"+
                  "<br /><div style='font-weight: bold;'>注意事项</div>"+
                  "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
                  "<br />2.	每位会员每年只可享受一次生日礼遇，或获得一张“生日券”；"+
                  "<br />3.	如在更改生日前，会员已获得平台发放的“生日券”（不论是否使用过）或已享受“生日礼遇”，则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日券”或获得“生日礼遇”；"+
                  "<br />4.	“生日券”和“生日礼遇”一旦成功预订，不可退订。若因会员自身原因未能准时到达预订现场，则该年的生日福利视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"}

              var tabjnew={'title':'会员生日福利',tx:'1.	黄金会员生日当天收到一张价值88元的“生日券”，用于抵扣高端酒店游泳健身或瑜伽服务二选一的预订费用（有效期14天）；<br>2.	生日祝福短信。',zn:
                      "<div><div style='font-weight: bold;'>黄金会员生日权益</div>"+
                "<br />1.	黄金会员生日当天收到一张价值88元的“生日券”，用于抵扣高端酒店游泳健身或瑜伽服务二选一的预订费用（有效期14天）；"+
                "<br />2.	该“生日券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
                "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一份生日券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
                "<br />4.	该“生日券”只可自用不得转赠，过期作废。</div>"+
                "<br /><div style='font-weight: bold;'>注意事项</div>"+
                "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
                "<br />2.	每位会员每年只可享受一次生日礼遇，或获得一张“生日券”；"+
                "<br />3.	如在更改生日前，会员已获得平台发放的“生日券”（不论是否使用过）或已享受“生日礼遇”，则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日券”或获得“生日礼遇”；"+
                "<br />4.	“生日券”和“生日礼遇”一旦成功预订，不可退订。若因会员自身原因未能准时到达预订现场，则该年的生日福利视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"}


                var tabb={'title':'会员生日福利',tx:'1.	铂金会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；<br>2.	生日祝福短信。',zn:
                    "<div><div style='font-weight: bold;'>铂金会员生日权益</div>"+
                    "<br />1.	铂金会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；"+
                    "<br />2.	该“生日券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
                    "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一份生日券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
                    "<br />4.	该“生日券”只可自用不得转赠，过期作废。</div>"+
                    "<br /><div style='font-weight: bold;'>注意事项</div>"+
                    "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
                    "<br />2.	每位会员每年只可享受一次生日礼遇，或获得一张“生日券”；"+
                    "<br />3.	如在更改生日前，会员已获得平台发放的“生日券”（不论是否使用过）或已享受“生日礼遇”，则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日券”或获得“生日礼遇”；"+
                    "<br />4.	“生日券”和“生日礼遇”一旦成功预订，不可退订。若因会员自身原因未能准时到达预订现场，则该年的生日福利视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"}

              var tabbnew={'title':'会员生日福利',tx:'1.	铂金会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；<br>2.	生日祝福短信。',zn:
                            "<div><div style='font-weight: bold;'>铂金会员生日权益</div>"+
                            "<br />1.	铂金会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；"+
                            "<br />2.	该“生日券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
                            "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一份生日券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
                            "<br />4.	该“生日券”只可自用不得转赠，过期作废。</div>"+
                            "<br /><div style='font-weight: bold;'>注意事项</div>"+
                            "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
                            "<br />2.	每位会员每年只可享受一次生日礼遇，或获得一张“生日券”；"+
                            "<br />3.	如在更改生日前，会员已获得平台发放的“生日券”（不论是否使用过）或已享受“生日礼遇”，则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日券”或获得“生日礼遇”；"+
                            "<br />4.	“生日券”和“生日礼遇”一旦成功预订，不可退订。若因会员自身原因未能准时到达预订现场，则该年的生日福利视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"}

                var tabz={'title':'会员生日福利',tx:'1.	钻石会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；<br>2.	生日祝福短信。',zn:
                          "<div><div style='font-weight: bold;'>钻石会员生日权益</div>"+
                          "<br />1.	钻石会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；"+
                          "<br />2.	该“生日券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
                          "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一份生日券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
                          "<br />4.	该“生日券”只可自用不得转赠，过期作废。</div>"+
                          "<br /><div style='font-weight: bold;'>注意事项</div>"+
                          "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
                          "<br />2.	每位会员每年只可享受一次生日礼遇，或获得一张“生日券”；"+
                          "<br />3.	如在更改生日前，会员已获得平台发放的“生日券”（不论是否使用过）或已享受“生日礼遇”，则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日券”或获得“生日礼遇”；"+
                          "<br />4.	“生日券”和“生日礼遇”一旦成功预订，不可退订。若因会员自身原因未能准时到达预订现场，则该年的生日福利视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"}

              var tabznew={'title':'会员生日福利',tx:'1.	钻石会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；<br>2.	生日祝福短信。',zn:
                        "<div><div style='font-weight: bold;'>钻石会员生日权益</div>"+
                        "<br />1.	钻石会员生日当天收到一张“生日券”，用于抵扣享受一次高端酒店游泳健身或瑜伽服务二选一（有效期14天）；"+
                        "<br />2.	该“生日券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
                        "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一份生日券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
                        "<br />4.	该“生日券”只可自用不得转赠，过期作废。</div>"+
                        "<br /><div style='font-weight: bold;'>注意事项</div>"+
                        "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
                        "<br />2.	每位会员每年只可享受一次生日礼遇，或获得一张“生日券”；"+
                        "<br />3.	如在更改生日前，会员已获得平台发放的“生日券”（不论是否使用过）或已享受“生日礼遇”，则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日券”或获得“生日礼遇”；"+
                        "<br />4.	“生日券”和“生日礼遇”一旦成功预订，不可退订。若因会员自身原因未能准时到达预订现场，则该年的生日福利视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"}



        var tabmold={'title':'精选星级酒店',tx:'一站式服务，足不出户看遍全国超五星酒店、五星级酒 店的健身、游泳、瑜伽场地。',zn:'1、本人预约88元/次，携亲友同行，亲友门市价188元/次；<br>2. 注：由于季节变化或酒店健身中心经营原因，酒店数量会根据实际情况有所调整和更新，同时每月酒店上新会发布推文通知。'}
        var tabmnew={'title':'精选星级酒店',tx:'一站式服务，足不出户看遍全国超五星酒店、五星级酒 店的健身、游泳、瑜伽场地。',zn:'1. 斐燃会员及同行亲友均可享受酒店游泳健身、瑜伽服务门市价五折；<br>2. 注：由于季节变化或酒店健身中心经营原因，酒店数量会根据实际情况有所调整和更新，同时每月酒店上新会发布推文通知。'}
        /**
         if(this.$route.params.disc=='a1'){
           this.tabs.unshift(dis1)
           // old
         }else{
           this.tabs.unshift(dis2)
           // new
         }
         */
        // // // console.log(this.$route.params)
        if(type==1){
          this.type_name='黄金'
          this.type_num=5

          if(this.$route.params.disc=='a1'){
			  this.tabs.push(tabj)
            this.tabs.push(tabmold)
          }else{
			  this.tabs.push(tabjnew)
            this.tabs.push(tabmnew)
          }
          // this.tabs.push(tabm2)
        }else if(type==2){
          this.type_name='铂金'
          this.type_num=6

          if(this.$route.params.disc=='a1'){
			  this.tabs.push(tabb)
            this.tabs.push(tabmold)
          }else{
			  this.tabs.push(tabbnew)
            this.tabs.push(tabmnew)
          }
        }else{
          this.type_name='钻石'
          this.type_num=6

          if(this.$route.params.disc=='a1'){
			  this.tabs.push(tabz)
            this.tabs.push(tabmold)
          }else{
			  this.tabs.push(tabznew)
            this.tabs.push(tabmnew)
          }
        }
        // // // // console.log(this.$route.params.active)
        if(type==1){
          this.activeMMM=this.$route.params.active-1
        }else{
          this.activeMMM=this.$route.params.active
        }


        /**
         {'title':'会员生日福利',tx:'会员可免费享受1次高端泳健服务；<br>生日祝福短信',zn:
                 "<div><div style='font-weight: bold;'>金卡生日权益</div>"+
           "<br />1.	金卡会员生日当天收到一张88元的“生日抵用券”，用于抵扣享受1次高端泳健服务（有效期14天）；"+
           "<br />2.	该“生日抵用券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
           "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一张88元的抵用券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
           "<br />4.	该“生日抵用券”只可自用不得转赠，过期作废。</div>"+

           "<br /><div><div style='font-weight: bold;'>铂金卡生日权益</div>"+
           "<br />1.	铂金卡会员生日当天收到一张88元的“生日抵用券”，用于抵扣享受1次高端泳健服务（有效期14天）；"+
           "<br />2.	该“生日抵用券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
           "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一张88元的抵用券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
           "<br />4.	该“生日抵用券”只可自用不得转赠，过期作废。</div>"+

           "<br /><div><div style='font-weight: bold;'>钻石卡生日权益</div>"+
           "<br />1.	钻石卡会员生日当天收到一张88元的“生日抵用券”，用于抵扣享受1次高端泳健服务（有效期14天）；"+
           "<br />2.	该“生日抵用券”将在会员生日当天发放到会员卡券包内，并收到祝福短信提醒；"+
           "<br />3.	祝福短信模板：尊贵的斐燃会员，感谢您对斐燃的信任，在您生日之际送上一份诚挚的祝福和一张88元的抵用券，请在有效期内使用，祝您生日愉快！会员专线：4006305888；"+
           "<br />4.	该“生日抵用券”只可自用不得转赠，过期作废。</div>"+

           "<br /><div style='font-weight: bold;'>注意事项</div>"+
           "<br />1.	会员生日为会员注册时填写的生日。若会员注册时没有填写或填写错误，可找客服出示身份证件为您填写或更改；"+
           "<br />2.	每位会员无论名下有几张会员卡，每年只可享受一次生日礼遇，领取一张“生日抵用券”；"+
           "<br />3.	如在更改生日前，会员已获得平台发放的“生日抵用券”（不论是否使用过），则更改后不可再次享受，需到次年才能在更新后的生日当天获得“生日抵用券”；"+
           "<br />4.	“生日抵用券”一旦成功预订，则不可退订。若因会员自身原因未能准时到达预订现场，则该生日礼遇视为已使用；若因场地方原因未能顺利入场，则可联系客服，为您更改预订时间和场地。"},
         {'title':'精选星级酒店',tx:'一站式服务，足不出户看遍全国超五星酒店、五星级酒 店的健身、游泳、瑜伽场地。',zn:'本人预约88元/次，携亲友同行，亲友188元次'},
         * */
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .vip_benefit{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    background: #ffffff;
    background-image: url(../../assets/images/base/equity_details_gold.png);
    background-position: left 90*@vm_base;
    background-size: auto 350*@vm_base;
    background-repeat: no-repeat;
  }
  .vip_benefit_title{
    width: 100%;
    padding: 90*@vm_base 80*@vm_base 0 80*@vm_base;
    .vip_benefit_title_title{
      font-size: 42*@vm_base;
      float: left;
      font-weight: 600;
      width: 100%;
      // height: 48*@vm_base;
      color: #C7C6CC;
      letter-spacing: 1px;
    }
    .vip_benefit_title_stitle{
      font-size: 28*@vm_base;
      font-weight: 500;
      float: left;
      color: #8F8C98;
      letter-spacing: 1px;
      width: 100%;
      padding-top: 20*@vm_base;
      // height: 32*@vm_base;
    }
  }
  .vip_benefit_cont{
    width: 100%;
    margin-top: 50*@vm_base;
    .vip_benefit_tab{
      padding:80*@vm_base 32*@vm_base 32*@vm_base 32*@vm_base;

      .vip_benefit_tab_item{
        // border: 1px solid red;
        padding: 40*@vm_base;
        margin-bottom: 40*@vm_base;
        background: #f8f8f8;
        border-radius: 12*@vm_base;
      }
      .vip_benefit_tab_title{
        width: 100%;
        font-size: 36*@vm_base;
        font-weight: 500;
        color: #333333;
      }
      .vip_benefit_tab_cont{
        width: 100%;
        padding-top: 30*@vm_base;
        border-radius: 12*@vm_base;
        font-size: 28*@vm_base;
        font-weight: 400;
        color: #444054;

      }
    }
  }
  .vip_benefit_tab_cont_viphotal{
    color:  #6699FF ;
    padding-left: 36*@vm_base;
    float: left;
    font-size: 28*@vm_base;
  }
</style>



// WEBPACK FOOTER //
// src/components/vip/vipBenefit.vue